import axios from 'axios'
import { Dispatch } from 'redux'
import apiErrorHandler from '../helpers/apiErrorHandler'
import { SectorHeater } from '../_types/sector-heaters.type'
import { CarnivoreEvent } from '../_types/carnivore-event.type'

const HEADERS = { 'Content-Type': 'application/json' }

const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/academy`,
    withCredentials: false
})

axiosInstance.interceptors.request.use(
    async req => {
        // Add configurations here
        req.headers['Authorization'] =
            'Bearer: ' + localStorage.getItem('carnivore-token')
        return req
    },
    err => {
        return Promise.reject(err)
    }
)

export class AcademyService {
    private dispatch: Dispatch

    constructor(dispatch: Dispatch) {
        this.dispatch = dispatch
    }
    async createAcademy(academy: any, tz: string) {
        return axiosInstance
            .post('/', {
                ...academy,
                timeZone: tz
            })
            .then(res => res.data.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }
    async getAcademyById(
        id: string,

    ) {
        return axiosInstance
            .get(`${id}`)
            .then(res => res?.data?.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }

    async searchAcademies(
        page: number,

    ) {
        return axiosInstance
            .get('/search', {
                params: {
                    page
                }
            })
            .then(res => res?.data?.data)
            .catch(e => apiErrorHandler(e, this.dispatch))
    }

}
